export default class {
   navbar = document.querySelector('.js_navbar');
   header = document.querySelector('.header');

   constructor() {
      this.listen();
   }

   listen() {
      window.addEventListener('scroll', () => {
         let coordHeader = this.header.getBoundingClientRect();
         if (coordHeader.bottom <= 0) {
            this.navbar.classList.add('navigation--fixed')
         } else {
            this.navbar.classList.remove('navigation--fixed')
         }         
      })
   }
}